import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the ReserveFieldRequiredPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'reserveFieldRequired',
})
export class ReserveFieldRequiredPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, isRequired) {
    if (isRequired) {
      value = `${value} *`
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/reserve-field-required/reserve-field-required.ts